import React from 'react';
import "../css/contact.css"
import CustomNavbar from '../components/Navbar';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { ContactUs } from '../components/contactForm';



function Contact() {

    return(
    <div>
        <CustomNavbar />

        <Header 
      title = "CONTACT US"
      subtext = "Reach out to us for inquiries, technical support, or feedback. Experience our exceptional service firsthand."
      imgURL = "/images/melted-chocolate-swirl.jpg"    />
    

<div className='contact'>
<div className='text-left'>
      <div className='text'>
      <h3 className='form-header'>Contact Information</h3>
      <p>Email: info@egeastern.com</p>
      <p>Phone: +201222177460</p>
      <p>Address: 46, Street 18, Sidi Bishr, Alexandria, Egypt</p>
      

        </div>

      <div className='text'>
      <h3 className='form-header'>Send Message</h3>
      
        <ContactUs />
      
        </div>
    </div>
    </div>

<div className='contact'>
<div className='text-left'>


    </div>
    </div>


        <Footer />
    </div>
    )
}

export default Contact;